module.exports = __webpack_public_path__ + "img/wxpayactive.5501f825.png";